import { getSessionData } from '@speeki/apollo-utils';
import { SentryService } from '@speeki/frontend-sentry';
import { StorageManager } from '@speeki/storage-manager';

export const sentry = new SentryService({
    sessionUser: getSessionData(StorageManager.getValue('graphSessionToken'))
        ?.user,
});
